<template>
  <div
    class="flex flex-grow items-center justify-between rounded-md border-2 border-transparent bg-off-white p-0"
    :class="{ activeButton: show && checked }"
  >
    <div class="inline-flex flex-grow">
      <label
        class="radio-container flex w-full"
        :class="{ 'text-dark-gray': show && checked }"
      >
        <slot />
        <div class="method-info-container flex">
          <div
            class="flex flex-col"
            style="line-height: 1.25"
            :class="{ 'text-dark-gray': checked, [customClass]: customClass }"
          >
            <span>{{ item }}</span>
            <span
              class="text-2xs font-bold uppercase"
              :class="checked ? 'text-body-color' : 'text-gray-over-dark'"
              >Saved {{ getSavedDate(method?.updated_at) }}</span
            >
          </div>
          <div
            v-if="method?.is_type == 'triumph_pay'"
            class="flex flex-col gap-1 rounded-md border px-2 py-1 text-xxs leading-3"
            :class="
              checked
                ? `border-transparent bg-off-white text-dark-gray ${subtextClass}`
                : `border-light-gray bg-white text-body-color ${subtextClass}`
            "
          >
            <div
              v-if="method?.triumph_pay_wallet_destination_type"
              class="flex flex-col"
            >
              <span
                class="text-2xs font-bold uppercase"
                :class="checked ? 'text-dark-gray' : 'text-gray-over-dark'"
                >Method</span
              >
              <span>{{
                method?.triumph_pay_wallet_destination_type == 'ach'
                  ? 'ACH Deposit'
                  : method?.triumph_pay_wallet_destination_type
                      ?.charAt(0)
                      .toUpperCase() +
                    method?.triumph_pay_wallet_destination_type?.slice(1)
              }}</span>
            </div>
            <div
              v-if="method?.triumph_pay_wallet_destination_type == 'check'"
              class="flex flex-col"
            >
              <span
                class="text-2xs font-bold uppercase"
                :class="checked ? 'text-dark-gray' : 'text-gray-over-dark'"
                >Address</span
              >
              <span>{{
                `${method?.triumph_pay_wallet_address_first_five}*****`
              }}</span>
              <span>{{
                `${method?.triumph_pay_wallet_remit_city},  ${method?.triumph_pay_wallet_remit_state}`
              }}</span>
            </div>
            <div
              v-else
              class="flex flex-col"
            >
              <span
                class="text-2xs font-bold uppercase"
                :class="checked ? 'text-dark-gray' : 'text-gray-over-dark'"
                >Bank Account Number</span
              >
              <span>{{
                'XXXXXX' + method?.triumph_pay_wallet_account_last_four
              }}</span>
            </div>
          </div>
          <div
            v-else-if="['ach', 'wire'].includes(method?.is_type)"
            class="flex flex-col gap-1 rounded-md border px-2 py-1 text-xxs leading-3"
            :class="
              checked
                ? `border-transparent bg-off-white text-dark-gray ${subtextClass}`
                : `border-light-gray bg-white text-body-color ${subtextClass}`
            "
          >
            <div class="flex flex-col">
              <span
                class="text-2xs font-bold uppercase"
                :class="checked ? 'text-dark-gray' : 'text-gray-over-dark'"
                >Routing #</span
              >
              <span>{{
                method?.routing_number_id
                  ? method?.routing_number_id?.replace(/\d(?=.*\d{4})/g, 'X')
                  : '-'
              }}</span>
            </div>
            <div class="flex flex-col">
              <span
                class="text-2xs font-bold uppercase"
                :class="checked ? 'text-dark-gray' : 'text-gray-over-dark'"
                >Account #</span
              >
              <span>{{ `XXXXXXXXX${method?.account_last_four}` }}</span>
            </div>
          </div>
          <div
            v-else-if="method?.is_type == 'check'"
            class="flex flex-col gap-1 rounded-md border px-2 py-1 text-xxs leading-3"
            :class="
              checked
                ? `border-transparent bg-off-white text-dark-gray ${subtextClass}`
                : `border-light-gray bg-white text-body-color ${subtextClass}`
            "
          >
            <div class="flex flex-col">
              <span
                class="text-2xs font-bold uppercase"
                :class="checked ? 'text-dark-gray' : 'text-gray-over-dark'"
                >Address</span
              >
              <span v-if="method?.street1">{{ method?.street1 }}</span>
              <span v-else>-</span>
              <span v-if="method?.street2">{{ method?.street2 }}</span>
              <span v-if="method?.city || method?.state || method?.postal_code"
                ><span v-if="method?.city">{{ `${method?.city}, ` }}</span
                ><span v-if="method?.state">{{ `${method?.state} ` }}</span
                ><span v-if="method?.city">{{
                  `${method?.postal_code}`
                }}</span></span
              >
              <span v-if="method?.country">{{ method?.country }}</span>
            </div>
          </div>
          <div
            v-else-if="['efs', 'comcheck', 'comchek'].includes(method?.is_type)"
            class="flex flex-col gap-1 rounded-md border px-2 py-1 text-xxs leading-3"
            :class="
              checked
                ? `border-transparent bg-off-white text-dark-gray ${subtextClass}`
                : `border-light-gray bg-white text-body-color ${subtextClass}`
            "
          >
            <div class="flex flex-col">
              <span
                class="text-2xs font-bold uppercase"
                :class="checked ? 'text-dark-gray' : 'text-gray-over-dark'"
                >Email Address</span
              >
              <span v-if="method?.email_address">{{
                method?.email_address
              }}</span>
              <span v-else>-</span>
            </div>
          </div>
          <div
            v-else-if="method?.is_type == 'cad_eft'"
            class="flex flex-col gap-1 rounded-md border px-2 py-1 text-xxs leading-3"
            :class="
              checked
                ? `border-transparent bg-off-white text-dark-gray ${subtextClass}`
                : `border-light-gray bg-white text-body-color ${subtextClass}`
            "
          >
            <div class="flex flex-col">
              <span
                class="text-2xs font-bold uppercase"
                :class="checked ? 'text-dark-gray' : 'text-gray-over-dark'"
                >Branch #</span
              >
              <span>{{
                method?.cad_eft_branch_number?.replace(/\d(?=.*\d{2})/g, 'X')
              }}</span>
            </div>
            <div class="flex flex-col">
              <span
                class="text-2xs font-bold uppercase"
                :class="checked ? 'text-dark-gray' : 'text-gray-over-dark'"
                >Bank #</span
              >
              <span>{{
                method?.cad_eft_bank_number?.replace(/\d(?=.*\d{2})/g, 'X')
              }}</span>
            </div>
            <div class="flex flex-col">
              <span
                class="text-2xs font-bold uppercase"
                :class="checked ? 'text-dark-gray' : 'text-gray-over-dark'"
                >Account #</span
              >
              <span>{{
                method?.cad_eft_account_number?.replace(/\d(?=.*\d{4})/g, 'X')
              }}</span>
            </div>
          </div>
          <div
            v-else-if="method?.is_type == 'echeck'"
            class="flex flex-col gap-1 rounded-md border px-2 py-1 text-xxs leading-3"
            :class="
              checked
                ? `border-transparent bg-off-white text-dark-gray ${subtextClass}`
                : `border-light-gray bg-white text-body-color ${subtextClass}`
            "
          >
            <div class="flex flex-col">
              <span
                class="text-2xs font-bold uppercase"
                :class="checked ? 'text-dark-gray' : 'text-gray-over-dark'"
                >Address</span
              >
              <span v-if="method?.street1">{{ method?.street1 }}</span>
              <span v-else>-</span>
              <span v-if="method?.street2">{{ method?.street2 }}</span>
              <span v-if="method?.city || method?.state || method?.postal_code"
                ><span v-if="method?.city">{{ `${method?.city}, ` }}</span
                ><span v-if="method?.state">{{ `${method?.state} ` }}</span
                ><span v-if="method?.city">{{
                  `${method?.postal_code}`
                }}</span></span
              >
              <span v-if="method?.country">{{ method?.country }}</span>
            </div>
            <div class="flex flex-col">
              <span
                class="text-2xs font-bold uppercase"
                :class="checked ? 'text-dark-gray' : 'text-gray-over-dark'"
                >Email Address</span
              >
              <span v-if="method?.email_address">{{
                method?.email_address
              }}</span>
              <span v-else>-</span>
            </div>
          </div>
        </div>
        <input
          type="radio"
          :value="value"
          :name="name"
          :checked="show && checked"
          :disabled="disabled"
          @click="handleClick"
        />
        <span class="checkmark" />
      </label>
    </div>
    <div
      v-if="['quick_pay', 'ach_deposit', 'triumph_pay'].includes(term)"
      class="relative flex items-center justify-center gap-1 px-1"
      style="top: -3px"
    >
      <div>
        <span
          class="text-xxs leading-3"
          :class="[checked ? 'text-dark-gray' : 'text-body-color']"
        >
          {{ term == 'triumph_pay' ? '' : 'Terms' }}
        </span>
      </div>
      <div class="margin-top-tooltip">
        <info-tooltip
          color-scheme="dark"
          content="'1'"
          class="relative"
          style="top: 1.5px"
        >
          <div>
            <p class="text-xxs">
              {{ getTextByTerm(term) }}
            </p>
          </div>
        </info-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import InfoTooltip from '@/components/InfoTooltip.vue';
import dayjs from 'dayjs';

export default {
  name: 'RoundRadioButtonSavedMethodWithTerms',
  components: { InfoTooltip },
  props: {
    method: Object,
    item: String,
    name: String,
    term: String,
    checked: Boolean,
    subtext: {
      type: String,
      default: '',
    },
    customClass: {
      type: String,
      default: '',
    },
    subtextClass: {
      type: String,
      default: '',
    },
    show: {
      type: Boolean,
      default: true,
    },
    value: [String, Boolean, Number],
    handleClick: {
      type: Function,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getSavedDate(date) {
      return dayjs(date).format('M/D/YY');
    },
    getTextByTerm(term) {
      const carrier = this.$store.state.carriers?.carrierDetails?.legal_name;
      const broker = this.$store.state.brokers?.logo.legal_name;
      switch (term) {
        case 'ach_deposit':
          return `${carrier} authorizes ${broker} to initiate electronic payment through the ACH system to the deposit account provided by ${carrier}.`;
        case 'quick_pay':
          return `By choosing Quick Pay, ${carrier} agrees to the terms of ${broker}'s Quick Pay program including early payment for a discount.`;
        case 'triumph_pay':
          return `You may edit the payment information provided in this connection to ${broker}, but you must contact TriumphPay directly to update your TriumphPay details.`;
        default:
          return '';
      }
    },
  },
};
</script>

<style scoped>
/* Custom CSS for Checkboxes */
/* Template used from W3 schools https://www.w3schools.com/howto/tryit.asp?filename=tryhow_css_custom_checkbox */
/* The container */
.radio-container {
  @apply relative flex h-full w-full cursor-pointer items-center justify-between py-2 pl-12 text-left text-sm text-body-color;
  /* height: 60px; */
  min-height: 60px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.radio-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  @apply absolute left-2 top-2/4 h-6 w-6 rounded-full bg-white;
  transform: translate(0, -50%);
}

/* When the checkbox is checked, add a yellow background */
.radio-container input:checked ~ .checkmark {
  @apply bg-yellow-500;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: '';
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.radio-container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.radio-container .checkmark:after {
  left: 8px;
  top: 8px;
  width: 8px;
  height: 8px;
  background-color: white;
  border: solid white;
  border-radius: 9999px;
}

.activeButton {
  @apply rounded-md border-2 border-yellow-500 bg-white;
  border-color: #f8c617 !important;
  background-color: white !important;
}
.margin-top-tooltip {
  margin-top: 10px;
}

@media (max-width: 420px) {
  .method-info-container {
    @apply flex-col items-start gap-1.5;
  }
}

@media (min-width: 420px) and (max-width: 768px) {
  .method-info-container {
    @apply w-full items-center gap-8;
  }
}

@media (min-width: 769px) {
  .method-info-container {
    /* @apply w-full items-center justify-between; */
    @apply w-full items-center gap-8;
  }
}
</style>
